import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { roofingServicePages } from "@/data/roofingServiceContent";

const c = roofingServicePages["roof-inspection"];

export const Route = createFileRoute("/services/roof-inspection")({
  head: () => ({
    meta: [
      { title: "Roof Inspection Southern California | McKay Roofing & Solar" },
      { name: "description", content: "Thorough roof inspections in Southern California with clear photo documentation and honest recommendations on repair or replacement." },
      { property: "og:title", content: "Roof Inspection – McKay Roofing & Solar" },
      { property: "og:description", content: c.heroSubtitle },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/roof-inspection" }],
  }),
  component: () => <RoofingServicePage {...c} />,
});